import React from 'react'

export default function Line() {
  return (
        <div style={{zIndex: '1'}} className="d-none d-md-block col-3">
            <hr className='border-top-0 border border-white' style={{zIndex: '1'}}/>
        </div>
    )
}
